import comp from "./CodeEditor";

export default comp;
